var e={content:"FullScreenGalleryContent-module_content__-f5W8",image:"FullScreenGalleryContent-module_image__slVDT"};export{e as default};
//# sourceMappingURL=FullScreenGalleryContent.module.scss.js.map
